import React from 'react'
import './forgetPW.css'
import { EmailForm } from '../../components/Forms/EmailForm/EmailForm';

const ForgetPassword = () => {
  return (
   
    <div className='ForgetPwContainer'>
    <EmailForm/>
      
    </div>
  
   
   
  )
}

export default ForgetPassword
